import {config} from '../config';
export default {
    getLoyaltyClub: () => config.data.loyaltyClub,
};
